<app-block-wrapper [_editable]="_editable" [style]="style">
  @for (blok of blocks; track blok._uid) {
    <ndc-dynamic
      [ndcDynamicComponent]="$any(components[blok.component])"
      [ndcDynamicInputs]="dynamicInputs($any(blok))"
    ></ndc-dynamic>
  }
</app-block-wrapper>
